import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    width: 17,
    height: 1,
    marginTop: 15.5,
    marginLeft: 1.5,
    marginBottom: 7,
    backgroundColor: PALETTE.primaryTextDisabled,
  },
});
